import { useState, useEffect, type ReactNode } from "react";
import { ThemeProvider } from "senzo-design-system";
import { useAuth } from "../auth/AuthProvider"; 
import { apiRequest } from '@/api/client';

interface CompanyProfile {
  readonly logo_url: string;
  readonly theme: Record<string, string>;
}

interface BrandingState {
  readonly logoUrl?: string;
  readonly theme?: Record<string, string>;
}

export function ThemeWrapper({ children }: { readonly children: ReactNode }) {
  const { token, isAuthenticated } = useAuth();
  
  const [branding, setBranding] = useState<BrandingState | undefined>(undefined);
  const [loading, setLoading] = useState(() => !!(isAuthenticated && token));

  useEffect(() => {
    if (!isAuthenticated || !token) {
      return;
    }

    let isMounted = true;

    async function loadBranding() {
      try {
        setLoading(true);
        const data = await apiRequest<CompanyProfile>('/v1/companies/profile', { token });
        
        if (isMounted) {
          setBranding({
            logoUrl: data.logo_url,
            theme: data.theme
          });
        }
      } catch (err) {
        console.error("Errore caricamento branding", err);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadBranding();

    return () => {
      isMounted = false;
    };
  }, [isAuthenticated, token]);

  const currentBranding = (isAuthenticated && token) ? branding : undefined;
  const isActualLoading = (isAuthenticated && token) ? loading : false;

  if (isActualLoading && isAuthenticated) {
    return <div className="loading-container">Caricamento stile...</div>;
  }

  return (
    <ThemeProvider branding={currentBranding}>
      {children}
    </ThemeProvider>
  );
}